import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { findProductsByCode } from '../utils/productPersistence';
import ZxingBarcodeScanner from './ZxingBarcodeScanner';

export default function PrepProductSearch({ country, onChoose, onCancel }) {
  const [code, setCode] = useState('');
  const [scanning, setScanning] = useState(false);
  const [matches, setMatches] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const request = useRef(0);
  useEffect(() => () => { request.current += 1; }, [country]);
  const search = async value => {
    const term = String(value ?? code).trim();
    if (!term || busy) return;
    const serial = ++request.current;
    setCode(term); setScanning(false); setBusy(true); setError(''); setMatches(null);
    try { const found = await findProductsByCode(country, term); if (found.some(p => p.country !== undefined && p.country !== country)) throw new Error('商品國家不符，請確認資料'); if (serial === request.current) setMatches(found); }
    catch (e) { setError(e.message); }
    finally { if (serial === request.current) setBusy(false); }
  };
  return <section className="prep-panel prep-search" aria-label="加入商品">
    <div className="prep-heading"><h2>加入商品</h2><button type="button" onClick={onCancel}>關閉</button></div>
    <form className="prep-search-form" onSubmit={e => { e.preventDefault(); search(); }}>
      <label>商品條碼／料號<input autoComplete="off" value={code} onChange={e => { setCode(e.target.value); setMatches(null); }} disabled={busy} placeholder="掃描或輸入條碼／料號" /></label>
      <button className="prep-primary" disabled={busy || !code.trim()}>{busy ? '查詢中…' : '查詢'}</button>
      <button type="button" disabled={busy} onClick={() => setScanning(v => !v)}>{scanning ? '關閉掃描' : '手機掃條碼'}</button>
    </form>
    {scanning && <ZxingBarcodeScanner scanning onScan={search} />}
    {error && <p role="alert" className="prep-error">{error}</p>}
    {matches?.length > 0 && <div className="prep-search-results">{matches.map(product => <button key={product.id} type="button" onClick={() => onChoose(product, code)}><strong>{product.name || '未填名稱'}</strong><span>料號 {product.itemNumber || '未填'} · 選擇款式 →</span></button>)}</div>}
    {matches?.length === 0 && <div className="prep-empty"><p>找不到「{code}」。</p><Link to={`/add/${country}?barcode=${encodeURIComponent(code)}`}>使用原表單新增商品</Link></div>}
  </section>;
}
